// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"9c59ba0f","787":"3436a2fa","858":"307543aa"}[chunkId] + ".chunk.js";
};